<div class="creator-container">
    <div class="header">
        <div class="header-actions">
            <h3>{{heading}}</h3>
            <button mat-icon-button (click)="openAddMedicationDialog()" matTooltip="Add new medication"
                *ngIf="!hideActions" color="primary">
                <mat-icon>add</mat-icon>
            </button>
        </div>

        <mat-checkbox *ngIf="!hideActions && !hideCheckbox" [(ngModel)]="noMedication" name="noMedication" class="checkbox"
            (change)="toggleNoMedication()">No Medication</mat-checkbox>
    </div>
    <ng-container *ngIf="!noMedication || hideActions">
        <mat-form-field class="full-width" appearance="outline" (click)="openAddMedicationDialog()">
            <mat-label>Medication</mat-label>
            <mat-chip-grid #chipGrid>
                <mat-chip-row *ngFor="let item of medications" (click)="$event.stopPropagation()"
                    [appTouchEdit]="!hideActions" (dblclick)="hideActions ? {} : editMedication(item)" [matTooltip]="getTooltipText(item)">
                    {{item.medication}}
                    <mat-icon *ngIf="reported(item)" class="patient-reported-mark" aria-label="Patient reported">person</mat-icon>
                    <button matChipRemove (click)="removeMedication(item)" *ngIf="!hideActions">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
            </mat-chip-grid>
            <input [matChipInputFor]="chipGrid" disabled />
            <mat-hint *ngIf="!hideActions">Double click or tap and hold an item to edit the information</mat-hint>
        </mat-form-field>

    </ng-container>

    <ng-template #addMedicationDialog>
        <h1 mat-dialog-title>Medication Details</h1>
        <div mat-dialog-content>
            <div class="p-t-20">

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Medication</mat-label>
                    <input matInput [(ngModel)]="editingMedication.medication" placeholder="Medication" type="text"
                        required>
                </mat-form-field>

                <mat-form-field appearance="outline" class="m-r-10">
                    <mat-label>Dosage</mat-label>
                    <input matInput [(ngModel)]="editingMedication.dosage" placeholder="Dosage" type="text">
                </mat-form-field>
            </div>

        </div>
        <div mat-dialog-actions class="dialog-actions">
            <button mat-raised-button color="primary" (click)="saveMedication()"
                [disabled]="!editingMedication.medication">Save</button>
        </div>

    </ng-template>
</div>